<template>
  <div class="login-page">
    <b-container>
      <b-row class="justify-content-center align-items-center" style="min-height: 80vh;">
        <b-col md="6" lg="5">
          <b-card class="shadow-sm border-0">
            <h2 class="text-center mb-4 font-weight-bold">{{ $t('auth.login_title') }}</h2>
            
            <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

            <b-form @submit.prevent="login">
              <b-form-group :label="$t('auth.email')" label-for="email">
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  :placeholder="$t('auth.email_placeholder')"
                ></b-form-input>
              </b-form-group>

              <b-form-group :label="$t('auth.password')" label-for="password">
                <b-form-input
                  id="password"
                  v-model="password"
                  type="password"
                  required
                  :placeholder="$t('auth.password_placeholder')"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="success" block class="mt-4" :disabled="loading">
                <b-spinner v-if="loading" small></b-spinner>
                <span v-else>{{ $t('auth.login_button') }}</span>
              </b-button>
            </b-form>

            <div class="text-center mt-3">
              <p class="text-muted">
                {{ $t('auth.no_account') }} 
                <router-link to="/signup" class="text-success font-weight-bold">{{ $t('auth.signup_link') }}</router-link>
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      loading: false
    }
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = '';
      try {
        await firebase.auth().signInWithEmailAndPassword(this.email, this.password);
        this.$router.push('/dashboard');
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}
</style>
